import { render, staticRenderFns } from "./whats_new_for_you_menu_item.vue.js?vue&type=template&id=2ba5613c!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./whats_new_for_you_menu_item.vue?vue&type=template&id=2ba5613c"
import script from "./whats_new_for_you_menu_item.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./whats_new_for_you_menu_item.vue?vue&type=script&lang=js"
export * from "./whats_new_for_you_menu_item.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./whats_new_for_you_menu_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ba5613c')) {
      api.createRecord('2ba5613c', component.options)
    } else {
      api.reload('2ba5613c', component.options)
    }
    module.hot.accept("./whats_new_for_you_menu_item.vue.js?vue&type=template&id=2ba5613c!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./whats_new_for_you_menu_item.vue?vue&type=template&id=2ba5613c", function () {
      api.rerender('2ba5613c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "whats_new/components/whats_new_for_you_menu_item.vue"
export default component.exports